import {IPresentation} from '../../../incase-domain/presentation';
import {ISlidePreview} from '../../../incase-domain/proptypes/slidePreview';

export const UPDATE_CURRENT_SLIDE = 'UPDATE_CURRENT_SLIDE';
export const UPDATE_LAST_SHOWED_SLIDE = 'UPDATE_LAST_SHOWED_SLIDE';

export const SCROLL_LEFT = 'SCROLL_LEFT';
export const SCROLL_RIGHT = 'SCROLL_RIGHT';

export const START_UPLOADED_PRESENTATION = 'START_UPLOADED_PRESENTATION';
export const JUMP_TO_SLIDE = 'JUMP_TO_SLIDE';
export const JUMP_TO_SLIDE_WITH_ID = 'JUMP_TO_SLIDE_WITH_INDEX';

export const UPDATE_LOADING_SLIDES = 'UPDATE_LOADING_SLIDES';

export const UPDATE_PRESENTATION_PREVIEWS = 'UPDATE_PRESENTATION_PREVIEWS_ACTION';
// export const FETCH_PRESENTATION_PREVIEWS = 'FETCH_PRESENTATION_PREVIEWS_ACTION';

export const UPDATE_SCALE = 'UPDATE_SCALE';
export const UPDATE_ARROWS_DISABLED = 'UPDATE_ARROWS_DISABLED';
export const SET_ACTIVE_MOBILE_QUESTION = 'SET_ACTIVE_MOBILE_QUESTION';
export const RESET_PRESENTATION_REDUCER = 'RESET_PRESENTATION_REDUCER';
export const SET_PREVENT_CLICK_TO_NEXT_SLIDE = 'SET_PREVENT_CLICK_TO_NEXT_SLIDE';

export const ADVANCE_SEQUENCE_STEP = 'ADVANCE_SEQUENCE_STEP';
export const RESET_SEQUENCE_QUEUE = 'RESET_SEQUENCE_QUEUE';
export const SET_SEQUENCE_QUEUE = 'SET_SEQUENCE_QUEUE';

export interface IAdvanceSequenceStep {
    type: typeof ADVANCE_SEQUENCE_STEP;
}

export interface IResetSequenceQueue {
    type: typeof RESET_SEQUENCE_QUEUE;
}

export interface ISetSequenceQueue {
    type: typeof SET_SEQUENCE_QUEUE;
    payload: Array<{elementId: string}>;
}

export interface IResetPresentationReducer {
    type: typeof RESET_PRESENTATION_REDUCER;
}

export interface ISetActiveMobileQuestion {
    type: typeof SET_ACTIVE_MOBILE_QUESTION;
    payload: string;
}

export interface IUpdatePresentationPreviewsAction {
    type: typeof UPDATE_PRESENTATION_PREVIEWS;
    payload: ISlidePreview[];
}

/* export interface IFetchPresentationPreviewsAction {
     type: typeof FETCH_PRESENTATION_PREVIEWS;
} */

export interface IStartUploadedPresentation {
    type: typeof START_UPLOADED_PRESENTATION;
    payload: IPresentation;
}

export interface IJumpToSlideWithId {
    type: typeof JUMP_TO_SLIDE_WITH_ID;
    payload: {slideId: string; overrideBlockers?: boolean};
}

export interface IJumpToSlide {
    type: typeof JUMP_TO_SLIDE;
    payload: {index: number; overrideBlockers?: boolean};
}

export interface IUpdatePresentationLoadingSlides {
    type: typeof UPDATE_LOADING_SLIDES;
    payload: boolean;
}

export interface IUpdateScaleAction {
    type: typeof UPDATE_SCALE;
    payload: number;
}

export interface IUpdateArrowsDisabledAction {
    type: typeof UPDATE_ARROWS_DISABLED;
    payload: boolean;
}

export interface IPreventClickToNextSlide {
    type: typeof SET_PREVENT_CLICK_TO_NEXT_SLIDE;
    payload: boolean;
}
